import { JobCard } from "../JobCard";

export function GridJob(props){
    // 데이터가 없으면 빈 화면 반환
    if (!props.object || props.object.length === 0) {
        return <></>;
    }

    return (
        <>
            {props.object.map((item, index) => (
                <div className="col-md-3" key={item.jobId || index}>
                    <JobCard 
                        object={item} 
                        index={index} 
                        cityList={props.cityList} 
                        returnTo={"/job_list"} 
                    />
                </div>
            ))}
        </>
    );
}